import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddWalletMoneyComponent } from "../add-wallet-money/add-wallet-money.component";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { ActivatedRoute } from "@angular/router";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { PointConversionComponent } from "../point-conversion/point-conversion.component";

@Component({
  selector: "sm-customer-wallet-money",
  templateUrl: "./customer-wallet-money.component.html",
  styleUrls: ["./customer-wallet-money.component.scss"],
})
export class CustomerWalletMoneyComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  walletTransactionData: any = [];
  walletData: any = {
    total: 0,
    monthly: 0,
    currency_symbol: "",
  };
  loader: boolean = false;
  pageNo: number = 1;
  constructor(
    private ns: NavigationService,
    private dialog: MatDialog,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private route: ActivatedRoute,
    private _modelRef: MatDialog
  ) {
    this.ns.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_USER_TOTAL_WALLET_AMOUNT_FOR_ENTITY
      ) {
        if (resdata.result) {
          this.walletData = {
            total: resdata.result.wallet_total_amount ?? 0,
            monthly: resdata.result.month_wallet_amount ?? 0,
            currency_symbol: resdata.result.currency_symbol ?? "",
          };

          this.apiservice.getUserWalletTransactionsListForEntity(
            this.entityHash,
            this.countrycode,
            this.phone,
            this.pageNo.toString()
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_USER_WALLET_TRANSACTIONS_LIST_FOR_ENTITY
      ) {
        this.walletTransactionData = [];
        if (resdata.result) {
          this.walletTransactionData = resdata.result;
          this.walletTransactionData.forEach((element: any) => {
            if (element.transaction_type == 1) {
                if(element.status == 2){
                  element.t_type = "Refunded to customer";

                }else{
                  element.t_type = "Credited to customer";
                }
            } else if (element.transaction_type == 2) {
              element.t_type = "Debited / Used";
            }
            
            element.duty_date = element.transaction_date;
            element.notes =
              element.notes && element.notes != "" && element.notes != "null"
                ? element.notes
                : "---";
            element.amt = element?.amount ?  `${element.currency_symbol}${element?.amount.toFixed(
              2
            )} ` : '---';
          });
        }
        this.loader = false;
        this.ls.showLoader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_WALLET_REFUND_STATUS
      ) {
        if (resdata.result) {
          this.apiservice.getUserTotalWalletAmountForEntity(
            this.entityHash,
            this.countrycode,
            this.phone
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_WALLET_TRANSACTION
      ) {
        if (resdata.result) {
          this.apiservice.getUserTotalWalletAmountForEntity(
            this.entityHash,
            this.countrycode,
            this.phone
          );
        }
      }
    });
  }

  entityHash: any;
  countrycode: any;
  phone: any;
  mn:any
  me:any
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
        this.countrycode = data.code;
        this.phone = data.phone;
        this.mn = data.mn;
        this.me = data.memail;
      }
    });

    this.loader = true;
    this.ls.showLoader = true;
    this.apiservice.getUserTotalWalletAmountForEntity(
      this.entityHash,
      this.countrycode,
      this.phone
    );
  }

  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: "Amount",
      columnProperty: "amt",
    },
    {
      columnName: "Notes",
      columnProperty: "notes",
    },
    {
      columnName: "Date",
      columnProperty: "duty_date",
    },
    {
      columnName: "Type",
      columnProperty: "t_type",
    },
  ];

  openwalletmoney() {
    let dref = this.dialog.open(AddWalletMoneyComponent, {
      width: "500px",
      data: {
        entity_hash: this.entityHash,
        phone: this.phone,
        country_code: this.countrycode,
        me: this.me
      },
    });
    dref.afterClosed().subscribe((data) => {
      if (data) {
        this.apiservice.getUserTotalWalletAmountForEntity(
          this.entityHash,
          this.countrycode,
          this.phone
        );
          if (data.errorcode == 0) {
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                data: {
                  title: "Success!",
                  message:
                    this.walletData.currency_symbol + data.amount.toFixed(2) + " Wallet Cash successfully credited.",
                  okbtn: "Ok",
                  cancelbtn: "No",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          } else {
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                data: {
                  title: "Alert!",
                  message:
                    "An error happened while crediting wallet cash. Try again.",
                  okbtn: "Ok",
                  cancelbtn: "No",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          }


      }
    });
  }


addpointconversion() {
  const dref = this.dialog.open(PointConversionComponent, {
    width: "500px",
    disableClose: true,   
    autoFocus: false
  });
}


  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  setRefundStatus(item: any, status: any) {
    let msg = "";
    if (status == 1) {
      msg = "Are you sure you want to revert the refund for this transaction?";
    } else if (status == 2) {
      msg = "Are you sure you want to mark this transaction as refunded?";
    }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: msg,
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          wallet_hash: item.wallet_hash,
          transaction_hash: item.hash_id,
          entity_hash: this.entityHash,
          status: status,
          creation_time: this.formatDateString(),
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        };

        this.ls.showLoader = true;
        this.apiservice.updateWalletRefundStatus(data);
      }
    });
  }
  deleteWalletTransaction(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this transaction?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          wallet_hash: item.wallet_hash,
          transaction_hash: item.hash_id,
          entity_hash: this.entityHash,
          status: 0,
          creation_time: this.formatDateString(),
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        };

        this.ls.showLoader = true;
        this.apiservice.deleteWalletTransaction(data);
      }
    });
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
